import React from "react";
import { KPITilesSection } from "./KPITiles/KPITilesSection";
import { CriticalSection } from "../impactAnalysis/CriticalSystems/CriticalSection";
import styles from "./bottlers.module.css";
import {Header} from '../bottlers/header/Header'


 const categories = [
    { category: 'Authentication Service', status: 'Healthy'},
    { category: 'Payment Gateway', status: 'Healthy'},
    { category: 'Database Cluster', status: 'Warning'},
    { category: 'CDN Network', status: 'Healthy' },
    { category: 'Message Queue', status: 'Critical' },
    { category: 'Analytics Service', status: 'Healthy' },
  ];
const Bottlers = () => {
  return (
    <div className="p-6 space-y-6">
        <div className={styles.headerWrapper}>
          <Header
            title='All Bottlers - KPI tiles(Orders/mins)'
            subtitle='Real-time system monitoring & incident management'
            rightActions={[
              { label: 'Minutes'},
              { label: 'Region : East + West' },
              { label: 'Auto by region'},
              { label: 'Refresh'},
            ]}
            notifications={{ count: 3, onClick: () => console.log('Notifications clicked!') }}
            actions={[
              { label: 'Refresh', onClick: () => console.log('Refresh') },
              { label: 'Export', onClick: () => console.log('Export') }
            ]}
          />
        </div>
        <div class="layout-common-scroll">
      {/* Top row of KPI Cards */}
      <KPITilesSection categories={categories} />

      {/* Bottom row */}
      <CriticalSection categories={categories} style={{ marginBottom: "24px" }} />
        </div>

    </div>
  );
};
export default Bottlers;
